<template>
  <li class="order-item uk-card uk-card-default uk-card-body">
    <div class="title-section uk-grid-small uk-child-width-1-3@m" uk-grid>
      <div>
        <div class="upper-row order-number">訂單編號：{{ o.order_num }}</div>
        <div class="lower-row">
          <span v-if="o.payment&&o.payment.status==='PAID'" class="payment-status paid">已付款完成</span>
          <span v-else-if="o.payment&&o.payment.status==='PENDING'" class="payment-status pending">未付款完成</span>
          <span v-else-if="o.payment&&o.payment.status==='EXPIRED'" class="payment-status expired">付款已逾期</span>
          <span v-else-if="o.payment&&o.payment.status==='FAILED'" class="payment-status failed">付款失敗</span>
          <span v-else-if="o.payment&&o.payment.status==='REFUND'" class="payment-status refund">已退款完成</span>
          <span v-else class="payment-status">未知狀態</span>
        </div>
      </div>
      <div>
        <div class="upper-row">訂單成立：
          <span v-if="o.created_at">{{ datetimeFormat(o.created_at) }}</span>
          <span v-else>-</span>
        </div>
        <div class="lower-row">付款時間：
          <span v-if="o.payment&&o.payment.paid_at">{{ datetimeFormat(o.payment.paid_at) }}</span>
          <span v-else>-</span>
        </div>
      </div>
      <div>
        <!-- <div class="upper-row" :class="{ 'hide-in-mobile': !toggle }">付款方式： -->
        <div class="upper-row">
          付款方式：
          <span v-if="o.payment&&o.payment.payment_method==='Credit'">信用卡</span>
          <span v-if="o.payment&&o.payment.payment_method==='ATM'">ATM</span>
          <span v-if="o.payment&&o.payment.payment_method==='CVS'">超商代碼</span>
        </div>
        <div class="lower-row">實付金額：
          <span style="color: #00626F;">NT${{ formatNumber(o.checkout_price) }}</span>
        </div>
      </div>
    </div>
    <div class="course-wrapper">
      <div class="course-inner">
        <div class="img-wrapper">
          <img v-if="o.course&&o.course.course_img" :src="o.course.course_img" alt="">
        </div>
        <div v-if="o.course" class="content">
          <div v-if="o.course.title" class="title">{{ o.course.title }}</div>
          <!-- <div v-if="o.course.sale_price" class="sale-price">NT${{ formatNumber(o.course.sale_price) }}</div> -->
        </div>
        <div class="toggle" @click="toggleOrder(o)">
          <span v-show="toggle" class="up">▲</span>
          <span v-show="!toggle" class="down">▼</span>
          查看訂單明細
        </div>
      </div>
    </div>
    <table v-show="toggle" class="rwd-table">
      <thead>
        <tr>
        <th class="uk-visible@s">價格明細</th>				
        <th>購買方案</th>				
        <th>售價</th>        
        <th>折扣</th>
        <th v-if="o.payment&&o.payment.payment_method==='CVS'" >超商手續費</th>
        <th>實付金額</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="uk-visible@s" data-head='價格明細'>{{ o.course.title }}</td>	
          <td data-head='購買方案'>{{ o.payment.payment_type === 'NORMAL' ? '正式課程' : '募資課程' }}</td>
          <td data-head='售價'>
            <span v-if="o.payment.payment_type === 'NORMAL'">NT${{ formatNumber(o.course.sale_price) }}</span>
            <span v-else-if="o.payment.payment_type === 'PREORDER'">NT${{ formatNumber(o.course.funding_price) }}</span>
          </td>
          <td data-head='折扣'>
            <span v-if="o.discounts.length===0">無折扣</span>
            <span v-for="n in o.discounts" :key="n.name">
              {{ n.name }}
              {{ n.discount_type === 'PERCENT' ? `NT$${formatNumber(Math.floor((o.payment.payment_type === 'PREORDER'?o.course.funding_price:o.course.sale_price)*(1 - n.value)))}` : n.discount_type === 'BY_VALUE' ? `NT$${formatNumber(n.value)}` : "-" }}
            </span>
          </td>
          <td data-head='超商手續費' v-if="o.payment&&o.payment.payment_method==='CVS'" >NT$ 30
          <td data-head='實付金額' style="color: #00626F; ">NT${{ formatNumber(o.checkout_price) }}</td>
        </tr>
      </tbody>
    </table>
    <div class="hr"></div>
  </li>
</template>

<script>
/* eslint-disable */

export default {
  name: 'AppOrderItem',
  props: ['o'],
  computed: {
    
  },
  data() {
    return {
      toggle: false
    }
  },
  methods: {
    formatNumber(num) {
      return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'): '0'
    },
    toggleOrder(o) {
      this.toggle = !this.toggle
    },
    datetimeFormat(time) {
      let d = new Date(time)
      return [d.getFullYear(),
              ("00" + (d.getMonth()+1).toString() ).slice(-2),
              ("00" + d.getDate().toString() ).slice(-2)
               ].join('/')
              + " " +
              [("00" + d.getHours()).slice(-2),
               ("00" + d.getMinutes()).slice(-2),
               ("00" + d.getSeconds()).slice(-2)].join(':')
    },
  },
  created() {
    
  }
}
</script>

<style scoped lang="scss">

</style>
